// Config compartida entre client y server. Ir sumando variables acá a medida que se necesiten

export const WHATSAPP_PHONE = '+5491162977619';
export const WHATSAPP_DEFAULT_MESSAGE = 'Hola, tengo una consulta: ';
